<template>
  <v-flex>
    <v-card :color="'rgb(250, 250, 250)'" class="elevation-2">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
          <span v-bind:style="{ color: 'white' }">{{ modelProveedor.nombre }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip label class="mr-4 px-5" link :color="'green lighten-1'" @click="_openGestionCalendarioTarifas()">
          <span v-bind:style="{ color: 'white' }">
            Gestionar Precios por Fechas
          </span>
        </v-chip>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link
          @click="_guardarProveedor(false)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarProveedor(true)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
        </v-chip>
        <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
      </v-toolbar>

      <v-container class="px-4 pt-4 pb-4">
        <v-row>
          <v-col>
            <v-tabs background-color="rgb(220, 220, 220)" grow v-model="tabGeneral">
              <v-tab v-for="(header, index) in tabHeadersGeneral" :key="index">
                {{ header }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabGeneral">
              <v-tab-item>
                <v-card>
                  <v-card-text>
                    <v-row class="mt-6">
                      <v-col>
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelProveedor.nombre" outlined label="Nombre" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelProveedor.nombre_alias" outlined label="Alias" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelProveedor.tipo"
                            label="Tipo"
                            :items="['Central reservas/op. turístico', 'Mayorista a comisión', 'Acreedor/Gastos']"></v-select>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.cif" :dark="dark" label="Cif" dense
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.contacto" :dark="dark" label="Contacto" dense
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.telefono" :dark="dark" label="Teléfono" dense
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.email" :dark="dark" label="Email" dense
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea outlined v-model="modelProveedor.observaciones" dense :dark="dark"
                            label="Observaciones"></v-textarea>
                        </v-row>

                        <v-row>
                          <v-col>

                          </v-col>
                        </v-row>




                      </v-col>

                      <v-divider vertical></v-divider>

                      <v-col>
                        <v-card class="mx-4">
                          <v-card-title>

                          </v-card-title>

                          <v-card-text>
                            <v-row dense class="mx-4">
                              <v-text-field outlined dense :dark="dark" autocomplete="off"
                                v-model="modelProveedor.localizacion"
                                placeholder="Coordenadas (latitud, longitud) Ej. 42.88443305902265, -8.527971575319986"
                                label="Localizacion"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4 mb-10">
                              <iframe class="mx-4"
                                :src="'https://maps.google.com/maps?q=' + modelProveedor.localizacion + '&z=12&output=embed'"
                                width="600" height="200" style="border:0;" allowfullscreen="" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.direccion" :dark="dark" label="Dirección"
                                dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.cod_postal" :dark="dark"
                                label="Codigo Postal" dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.poblacion" :dark="dark" label="Población"
                                dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.provincia" :dark="dark" label="Provincia"
                                dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-text-field outlined v-model="modelProveedor.pais" :dark="dark" label="País" dense
                                autocomplete="off"></v-text-field>
                            </v-row>
                          </v-card-text>
                        </v-card>



                      </v-col>
                    </v-row>

                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-card-text>
                    <v-row class="mt-6">
                      <v-col>

                        <v-row dense class="mx-4 mb-4">
                          <v-select outlined dense :dark="dark" autocomplete="off"
                            v-model="modelProveedor.categoriaProveedor" label="Categoría de Proveedor"
                            :items="categoriasProveedor" return-object item-text="nombre" item-value="id"
                            @input="_actualizarCategoriaProveedor"></v-select>
                        </v-row>


                        <v-row dense class="mx-4">
                          <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelProveedor.punto"
                            label="Punto de localización" :items="puntosProveedores" return-object item-text="nombre"
                            item-value="id"></v-select>
                        </v-row>

                       




                        <v-row dense class="mx-6 mb-2"
                          v-if="modelProveedor.categoriaProveedor && modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <h3>Seleccione los regimenes, tipos y características de las habitaciones disponibles del
                            alojamiento.</h3>
                        </v-row>


                        <v-row dense class="mx-4 mb-4"
                          v-if="modelProveedor.categoriaProveedor && modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <v-col>
                            <v-card class="elevation-0" :color="'rgb(250, 250, 250)'">
                              <v-card-text>
                                <v-checkbox dense multiple v-for="regimen in regimenes" :key="regimen.id"
                                  v-model="regimenesSeleccionados" :label="regimen.nombre" :value="regimen.id"
                                  @change="_actualizarTarifasAutoGeneradas"></v-checkbox>
                              </v-card-text>
                            </v-card>

                          </v-col>

                          <v-divider vertical></v-divider>

                          <v-col>
                            <v-card class="elevation-0" :color="'rgb(250, 250, 250)'">
                              <v-card-text>
                                <v-checkbox dense multiple v-for="tiposHabitacion in tiposHabitacion"
                                  :key="tiposHabitacion.id" v-model="tiposHabitacionSeleccionados"
                                  :label="tiposHabitacion.nombre" :value="tiposHabitacion.id"
                                  @change="_actualizarTarifasAutoGeneradas"></v-checkbox>
                              </v-card-text>
                            </v-card>

                          </v-col>

                          <v-divider vertical></v-divider>

                          <v-col>
                            <v-card class="elevation-0" :color="'rgb(250, 250, 250)'">
                              <v-card-text>
                                <v-checkbox dense multiple v-for="caracteristica in caracteristicasHabitacion"
                                  :key="caracteristica.id" v-model="caracteristicasHabitacionSeleccionadas"
                                  :label="caracteristica.nombre" :value="caracteristica.id"
                                  @change="_actualizarTarifasAutoGeneradas"></v-checkbox>
                              </v-card-text>
                            </v-card>
                          </v-col>

                        </v-row>


                        <v-row dense class="mx-6 mt-6"
                          v-if="modelProveedor.categoriaProveedor && modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <v-col>

                            <v-row dense class="mx-4">
                              <v-switch v-model="modelProveedor.ofrecen_cena" hide-details dense
                                :label="`${modelProveedor.ofrecen_cena ? ' Picnic' : ' Picnic'}`"></v-switch>
                            </v-row>

                            <v-row dense class="mx-4">
                              <v-switch v-model="modelProveedor.ofrecen_cena_terceros" hide-details dense
                                :label="`${modelProveedor.ofrecen_cena_terceros ? ' Cena de terceros' : ' Cena de terceros'}`"></v-switch>
                            </v-row>

                            <v-row dense class="mx-4 mb-4">
                              <v-switch v-model="modelProveedor.mascotas" hide-details dense
                                :label="`${modelProveedor.mascotas ? ' Mascotas' : ' Mascotas'}`"></v-switch>
                            </v-row>

                          </v-col>
                        </v-row>
                      </v-col>

                      <v-divider vertical></v-divider>

                      <v-col>

                        <v-data-table locale="es" dense :headers="headersTarifas" :items="tarifasAutoGeneradas"
                          :items-per-page="tarifasAutoGeneradas.length"
                          class="elevation-1 alternating-rows bordered-table" hide-default-footer>
                          <template v-slot:top>
                            <v-toolbar dense :color="colorBarraFormulario" dark flat>
                              <v-toolbar-title>Tarifas disponibles</v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </template>

                          <template v-slot:no-data>
                            No hay tarifas disponibles
                          </template>

                        </v-data-table>

                        <!--    <v-row justify="center" dense class="mx-6 mt-8"
                          v-if="modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <h2 class="text-center">Para agregar los precios de las tarifas debe acceder a la Gestion de Regla
                            botón, para
                            agregarlas por fechas o días de
                            la semana. </h2>
                        </v-row>

                        <v-row justify="center" dense class="mx-6 mt-8"
                          v-if="modelProveedor.categoriaProveedor.nombre === 'Alojamiento'">
                          <v-chip label class="mr-2" link :color="'green lighten-1'" @click="_openGestionCalendarioTarifas()">
                            <span v-bind:style="{ color: 'white' }">
                              Gestionar Precios por Fechas
                            </span>
                          </v-chip>
                        </v-row>

                        -->


                      </v-col>
                    </v-row>

                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-card-text>
                    <v-row class="mt-6">
                      <v-col>
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelProveedor.nombre_alias" outlined label="Alias" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.direccion" :dark="dark" label="Dirección" dense
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.cod_postal" :dark="dark" label="Codigo Postal"
                            dense autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.poblacion" :dark="dark" label="Población" dense
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined v-model="modelProveedor.telefono" :dark="dark" label="Teléfono" dense
                            autocomplete="off"></v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>

          </v-col>
        </v-row>

      </v-container>

    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "ProveedorFormulario",
  components: {},
  data: () => ({
    loading: false,

    tabDirecciones: null,
    tabHeadersDirecciones: ['Direccion', 'DireccionFiscal'],

    tabGeneral: null, // Para controlar el tab activo
    tabHeadersGeneral: ['Datos Generales', 'Tipología', 'Datos Bono'],

    headersTarifas: [
      { text: 'REGIMEN', value: 'regimen_titulo' },
      { text: 'HABITACION-CARACTERISTICA', value: 'habitacion_caracteristica_titulo' },
      { text: '', value: 'actions', align: 'end', width: '100px' },
    ],

    tiposSeleccionados: [],

    regimenesSeleccionados: [],
    tiposHabitacionSeleccionados: [],
    caracteristicasHabitacionSeleccionadas: [],

    tarifasAutoGeneradas: [],

    dialogFormularioCalendarioTarifas: false,


  }),

  props: {
    modelProveedor: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "tiposProveedor",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("proveedores", [
      "regimenes",
      "categoriasProveedor",
      "tiposHabitacion",
      "caracteristicasHabitacion",
      "puntosProveedores",
    ]),



  },

  watch: {
    modelProveedor(newVal) {
      console.log('modelProveedorFormulario:', this.modelProveedor);
      this.regimenesSeleccionados = this.modelProveedor.regimenes && this.modelProveedor.regimenes.length > 0 ? this.modelProveedor.regimenes.map(regimen => regimen.id) : [];
      this.tiposHabitacionSeleccionados = this.modelProveedor.tipoHabitaciones && this.modelProveedor.tipoHabitaciones.length > 0 ? this.modelProveedor.tipoHabitaciones.map(tiposHabitacion => tiposHabitacion.id) : [];
      this.caracteristicasHabitacionSeleccionadas = this.modelProveedor.caracteristicasHabitaciones && this.modelProveedor.caracteristicasHabitaciones.length > 0 ? this.modelProveedor.caracteristicasHabitaciones.map(caracteristica => caracteristica.id) : [];
      this.tarifasAutoGeneradas = this.modelProveedor.tarifas && this.modelProveedor.tarifas.length > 0 ? this.modelProveedor.tarifas : [];
      console.log('tarifasAutoGeneradas:', this.tarifasAutoGeneradas);
    }
  },

  mounted() {
    console.log('modelProveedorFormulario:', this.modelProveedor);
    this.regimenesSeleccionados = this.modelProveedor.regimenes && this.modelProveedor.regimenes.length > 0 ? this.modelProveedor.regimenes.map(regimen => regimen.id) : [];
    this.tiposHabitacionSeleccionados = this.modelProveedor.tipoHabitaciones && this.modelProveedor.tipoHabitaciones.length > 0 ? this.modelProveedor.tipoHabitaciones.map(tiposHabitacion => tiposHabitacion.id) : [];
    this.caracteristicasHabitacionSeleccionadas = this.modelProveedor.caracteristicasHabitaciones && this.modelProveedor.caracteristicasHabitaciones.length > 0 ? this.modelProveedor.caracteristicasHabitaciones.map(caracteristica => caracteristica.id) : [];
    this.tarifasAutoGeneradas = this.modelProveedor.tarifas && this.modelProveedor.tarifas.length > 0 ? this.modelProveedor.tarifas : [];
    console.log('tarifasAutoGeneradas:', this.tarifasAutoGeneradas);
  },

  methods: {
    ...mapActions("proveedores", ["getProveedores", "crearProveedor", "updateProveedor"]),
    ...mapActions("puntos", ["getPuntos"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioProveedor");
    },

    _actualizarCategoriaProveedor(value) {
      console.log('value:', value);
      if (value.nombre !== 'Alojamiento') {
        this.tarifasAutoGeneradas = [];
      } else {
        // this._actualizarTarifasAutoGeneradas();
      }
    },

    _guardarTarifasAutogeneradas() {
      this.dialogFormularioCalendarioTarifas = true;
    },

    _actualizarTarifasAutoGeneradas() {
      this.tarifasAutoGeneradas = [];

      this.regimenesSeleccionados.sort((a, b) => a - b);
      this.tiposHabitacionSeleccionados.sort((a, b) => a - b);
      this.caracteristicasHabitacionSeleccionadas.sort((a, b) => a - b);

      this.regimenesSeleccionados.forEach(regimen => {
        this.caracteristicasHabitacionSeleccionadas.forEach(caracteristica => {
          this.tiposHabitacionSeleccionados.forEach(tipoHabitacion => {

            let regimen_titulo = this.regimenes.find(reg => reg.id === regimen).nombre;
            let tipoHabitacionNombre = this.tiposHabitacion.find(tipo => tipo.id === tipoHabitacion).nombre;
            let caracteristicaNombre = this.caracteristicasHabitacion.find(caract => caract.id === caracteristica).nombre;

            let habitacion_caracteristica_titulo = tipoHabitacionNombre + " - " + caracteristicaNombre;

            if (caracteristicaNombre === 'Estandar') {
              habitacion_caracteristica_titulo = tipoHabitacionNombre;
            }

            this.tarifasAutoGeneradas.push({
              proveedor_id: this.modelProveedor.id,
              regimen_id: regimen,
              tipo_habitacion_id: tipoHabitacion,
              caracteristica_habitacion_id: caracteristica,
              regimen_titulo: regimen_titulo,
              habitacion_caracteristica_titulo: habitacion_caracteristica_titulo,
            });

          });
        });
      });
    },

    _openGestionCalendarioTarifas() {

      this.$router.push({ name: 'ProveedoresReglasTarifas' });
    },

    _deleteTarifaAutoGenerada(tarifa) {
      console.log(tarifa);
      this.tarifasAutoGeneradas = this.tarifasAutoGeneradas.filter(t => t.regimen_id !== tarifa.regimen_id ||
        t.tipo_habitacion_id !== tarifa.tipo_habitacion_id ||
        t.caracteristica_habitacion_id !== tarifa.caracteristica_habitacion_id);
    },

    async _guardarProveedor(cerrar) {
      this.loading = true;
      this.modelProveedor.categoria_proveedor_id = this.modelProveedor.categoriaProveedor ? this.modelProveedor.categoriaProveedor.id : null;
      this.modelProveedor.punto_id = this.modelProveedor.punto ? this.modelProveedor.punto.id : null;

      if (this.accion == "crear") {
        var res = await this.crearProveedor([
          this.access_token,
          this.modelProveedor,
        ]);
        const params = {};
      } else if (this.accion == "editar") {
        var res = await this.updateProveedor([
          this.access_token,
          this.modelProveedor,
          this.regimenesSeleccionados,
          this.tiposHabitacionSeleccionados,
          this.caracteristicasHabitacionSeleccionadas,
          this.tarifasAutoGeneradas,
        ]);
      }
      if (cerrar) {
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>
